import React from 'react';
import { Button } from '@raptormaps/button';
import { Stack } from '@raptormaps/layout';
import { Text } from '@raptormaps/text';
import { PartnerFarmLink } from '../../api/services/solar-farm-partners';

interface PartnerViewProps {
  activeLink: PartnerFarmLink;
  onEdit: () => void;
}

export function PartnerView({ activeLink, onEdit }: PartnerViewProps) {
  return (
    <Stack gutter="md">
      <Stack gutter="xxs">
        <Text variant="label_small_allcaps" color="#718096">
          Partner
        </Text>
        <Text variant="paragraph_medium">{activeLink.partner.name}</Text>
      </Stack>
      <Stack gutter="xxs">
        <Text variant="label_small_allcaps" color="#718096">
          Partner Key
        </Text>
        <Text variant="paragraph_medium">{activeLink.partner_farm_key}</Text>
      </Stack>
      <Button variant="secondary" onClick={onEdit}>
        Edit
      </Button>
    </Stack>
  );
}
